import { lazyWithRetry } from "utils";

export { default as PatientDetailsForm } from "./containers/PatientDetailsForm";
export const PatientInfo = lazyWithRetry(() => import("./containers"));